import script from "./Stepper.vue?vue&type=script&setup=true&lang=ts"
export * from "./Stepper.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QStepper,QStep,QStepperNavigation});
